"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _index = require("./index");

var _reactRouter = require("react-router");

var getScrollPercentage = function getScrollPercentage(element) {
  var pageClientRects = element.getBoundingClientRect();
  var pageHeight = pageClientRects.height;
  var windowHeight = window.innerHeight;
  var scrollHeight = pageHeight - windowHeight;
  var offsetYPercent = Math.round(Math.abs(pageClientRects.top) * 100 / scrollHeight);
  return offsetYPercent;
};

var triggers = [25, 50, 75, 100];

var useAnalyticsEventScroll = function useAnalyticsEventScroll(_ref) {
  var analytics = _ref.analytics,
      ref = _ref.ref;

  var _useState = (0, _react.useState)(0),
      attachedScrollPercent = _useState[0],
      setAttachedScrollPercent = _useState[1];

  var Analytics = (0, _index.useAnalytics)();
  var location = (0, _reactRouter.useLocation)();
  var pushScrollEvent = (0, _react.useCallback)(function (percentage) {
    if (Analytics.enabled) {
      setAttachedScrollPercent(percentage);
      Analytics.event({
        category: 'Scroll',
        action: percentage + "%",
        label: location.pathname + location.search
      });
    }
  }, [Analytics, location.pathname, location.search]);
  (0, _react.useEffect)(function () {
    if (Analytics.enabled) {
      if (analytics && ref.current) {
        var onScroll = function onScroll(event) {
          var offsetYPercent = getScrollPercentage(ref.current);
          var currentPercentil = triggers.find(function (percent, index, percents) {
            var isLast = index === percents.length - 1;
            return offsetYPercent >= percent && (isLast || offsetYPercent < percents[index + 1]);
          });

          if (currentPercentil > attachedScrollPercent) {
            pushScrollEvent(currentPercentil);
          }
        };

        document.addEventListener('scroll', onScroll);
        return function () {
          document.removeEventListener('scroll', onScroll);
        };
      }
    }
  }, [analytics, attachedScrollPercent, pushScrollEvent, ref, Analytics.enabled]);
};

var _default = useAnalyticsEventScroll;
exports.default = _default;